/**
 * 화면 위치 헤더(X-Client-App·X-Audit-Screen) — 계약 AUDIT 2절 `screen`·`source.app`.
 * 표시용이라 서버 판정에 쓰이지 않는다. 형식이 틀리면 헤더를 빼고 보낸다(서버 cleanScreen() 도 버림).
 * Vue·axios 를 들이지 않는 순수 모듈이라 node --test 로 시험한다(tests/clientHeaders.test.mjs).
 */
export const CLIENT_APP = 'admin-reseller';
const SCREEN_RE = /^[A-Za-z0-9_.:/#-]{1,64}$/; // 서버 cleanScreen() 과 같은 식

let currentScreen;

const valid = (v) =>
  typeof v === 'string' && SCREEN_RE.test(v) ? v : undefined;

/** 라우트 → 화면 위치 값: name(형식이 맞을 때) → 경로 틀(/customers/:id) → 없음(헤더를 뺌) */
export const screenOf = (route) => {
  if (!route) return undefined;
  const matched = route.matched || [];
  const last = matched[matched.length - 1];
  return valid(route.name) || valid(last && last.path);
};

/** router.afterEach 에서 부른다 */
export const setAuditScreen = (route) => {
  currentScreen = screenOf(route);
};

/** axios 요청 가로채기에서 부른다 */
export const withClientHeaders = (config) => {
  config.headers = config.headers || {};
  config.headers['X-Client-App'] = CLIENT_APP;
  if (currentScreen) config.headers['X-Audit-Screen'] = currentScreen;
  else delete config.headers['X-Audit-Screen'];
  return config;
};
